import axios from "axios";

export default class AccountNotificationForm {

    form: HTMLFormElement

    constructor(form: HTMLFormElement) {
        this.form = form;
        this.initEvents();
    }

    initEvents() {
        this.form.addEventListener('submit', e => {
            e.preventDefault();
            this.setLoading(true);

            updateNotificationRequest(this.form).then( () => {
                this.setLoading(false);
            });
        });
    }

    setLoading( toggle: boolean ){
        this.form.querySelectorAll<HTMLElement>( 'button' ).forEach( el => toggle ? el.classList.add('ajax-loading') : el.classList.remove('ajax-loading') );
    }

}

const updateNotificationRequest = (form: HTMLFormElement) => {
    let formData = new FormData(form);

    return axios.post(window.location.toString(), formData);
}